import { useState, useContext, createContext, useEffect, useRef } from 'react'
const AppContext = createContext<any | undefined>(undefined)
import { toast } from 'react-toastify'
import { get } from './Api'
// import { get } from './Api'

const AppProvider = ({ children }: any) => {
  const adminToken: any = sessionStorage.getItem('token')

  const notify = (type: string, message: string) => {
    if (type === 'info') {
      toast.info(message)
    }
    if (type === 'success') {
      toast.success(message)
    }
    if (type === 'warn') {
      toast.warn(message)
    }
    if (type === 'error') {
      toast.error(message)
    }
  }
  const [toggleSidebar, setToggleSidebar] = useState(false)
  const handleSidebarToggle = () => {
    setToggleSidebar(!toggleSidebar)
  }
  const closeSideBar = () => {
    if (toggleSidebar) {
      setToggleSidebar(!toggleSidebar)
    }
  }
  const calculatePaymentAmount = (input: number | string): number => {
    let amount = typeof input === 'string' ? parseFloat(input) : input
    let calculatedValue = amount * 0.015 + 100
    return parseFloat(Math.min(calculatedValue, 2000).toFixed(2))
  }
  // User Profile
  const [profileLoading, setProfileLoading] = useState(true)
  let profile: any = sessionStorage.getItem('user')
    ? JSON.parse(sessionStorage.getItem('user') || '')
    : {}
  function fetchUserProfile() {
    setProfileLoading(true)
    if (profile && profile.status === 'inactive') {
      sessionStorage.clear()
      notify('error', 'Access restricted. Your account is inactive.')
      window.location.replace('/')
      return
    }
    get('admin/profile')
      .then((result: any) => {
        if (result.status === 200) {
          sessionStorage.setItem('user', JSON.stringify(result.data))
          setProfileLoading(false)
        } else if (result.status === 403) {
          sessionStorage.clear()
          window.location.replace('/')
          setProfileLoading(false)
        } else {
          notify('error', result.message)
        }
      })
      .catch(() => {
        setProfileLoading(false)
      })
  }

  //<-------------------------Admin Wallet-------------------------->
  const [adminWalletLoading, setAdminWalletLoading] = useState(true)
  const [adminWalletData, setAdminWalletData] = useState<any>({})

  function fetchAdminWallet() {
    setAdminWalletLoading(true)
    get('admin/wallet')
      .then((result: any) => {
        if (result.status === 200) {
          setAdminWalletData(result.data)
          setAdminWalletLoading(false)
        } else {
          notify('error', result.message)
        }
      })
      .catch(() => {
        setAdminWalletLoading(false)
      })
  }

  //<-------------------------Shipment Tags-------------------------->
  // Held globally so the booking lists, the detail views and the filter
  // dropdowns all share one fetch. Inactive tags are included: a shipment
  // tagged before the tag was deleted must still render its name.
  const [tags, setTags] = useState<any[]>([])
  const [tagsLoading, setTagsLoading] = useState(false)

  function fetchTags() {
    setTagsLoading(true)
    get('admin/tags?includeInactive=true')
      .then((result: any) => {
        if (result.status === 200) {
          setTags(result.data?.tags || [])
        } else {
          notify('error', result.message || 'Failed to fetch tags')
        }
        setTagsLoading(false)
      })
      .catch(() => {
        notify('error', 'Failed to fetch tags')
        setTagsLoading(false)
      })
  }

  // Fetch the taxonomy once per session, as soon as a token exists.
  //
  // This deliberately does NOT depend on the token value: every get() calls
  // generateToken(), which writes a fresh access token to sessionStorage, so a
  // token-valued dependency changes after every request and re-fires forever.
  //
  // The provider sits above the router, so it mounts on the login page before
  // any token exists and is never remounted by the post-login navigate() —
  // the dashboard calls ensureTags() on mount to cover that case. The ref
  // makes it idempotent, so the two entry points can't double-fetch.
  const tagsRequested = useRef(false)

  function ensureTags() {
    if (tagsRequested.current) return
    if (!sessionStorage.getItem('token')) return
    tagsRequested.current = true
    fetchTags()
  }

  useEffect(() => {
    ensureTags()
  }, [])

  // id -> tag, for turning the id arrays on a booking into chips.
  const tagsById = tags.reduce((acc: any, tag: any) => {
    acc[tag._id] = tag
    return acc
  }, {})

  return (
    <AppContext.Provider
      value={{
        notify,
        adminToken,
        handleSidebarToggle,
        toggleSidebar,
        closeSideBar,
        profile,
        profileLoading,
        fetchUserProfile,
        calculatePaymentAmount,
        fetchAdminWallet,
        adminWalletLoading,
        adminWalletData,
        tags,
        tagsById,
        tagsLoading,
        fetchTags,
        ensureTags,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}

export const useGlobalContext = () => {
  return useContext(AppContext)
}

export { AppContext, AppProvider }
